import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import { getBulkDropdownData, getDropdownData } from "../../../api/keyvalue";
import { itemCreationValidation } from "../../validations/DeductionCreation";
import {
  checkApprovalTypeExists,
  checkApprovalTypeExistsByAppType,
} from "../../../api/ApprovalMasterApi";
import { toast } from "react-toastify";
import { FORMS, MODULES } from "../../../const";
import useUserCompany from "../../../hooks/useUserCompany";

const FORM = FORMS.ITEM.APPROVAL.form;

const ApprovalMasterHeaderForm = forwardRef(
  (
    {
      errors,
      dropdown,
      isLoading,
      setIsAppTypeExists,
      currentValues,
      editMode,
      setApprovalTypes,
      setHeaderAudit
    },
    ref
  ) => {
    const userCompany = useUserCompany();
    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);
    const [approvalHeaderData, setApprovalHeaderData] = useState(
      editMode
        ? {
            ...currentValues,
          }
        : {
            appCode: "",
            appReference: "",
            appCompnay: company,
            appName: "",
            appApprovals: "",
            appLevels: "",
            appDescription: "",
            appStatus: 2,
            appActive: 1,
          }
    );

    useEffect(() => {
      if (editMode) {
      setHeaderAudit(currentValues)
      }
    }, [currentValues, editMode])
    

    const [currentErrors, setCurrentErrors] = useState(errors);
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    // dropdown
    const [approvalTypeOpt, setApprovalTypeOpt] = useState([]);
    const [appStatusOpt, setAppStatusOpt] = useState([]);
    const [appActiveOpt, setAppActiveOpt] = useState([]);

    useEffect(() => {
      (async () => {
        //new

        const {
          status,
          active,
          approval_types: approvalTypesOpt,
        } = await getBulkDropdownData([
          { key: "status" },
          { key: "active" },
          { key: "approval_types" },
        ]);
        setApprovalTypeOpt(approvalTypesOpt);
        setAppStatusOpt(status);
        setAppActiveOpt(active);
      })();
    }, []);

    useEffect(() => {
      setApprovalTypes(approvalHeaderData.appApprovals);
    }, [approvalHeaderData]);

    useImperativeHandle(ref, () => ({
      getData: () => approvalHeaderData,
      resetForm: () => {
        setApprovalHeaderData({
          appCode: "",
          appReference: "",
          appCompnay: "",
          appName: "",
          appApprovals: "",
          appLevels: "",
          appDescription: "",
          appStatus: 2,
          appActive: 1,
        });
      },
    }));

    const checkApprovalTypeExists = async (data) => {
      const response = await checkApprovalTypeExistsByAppType(data);
      if (response === true) {
        toast.error("Approval Type Already Exist!", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
      setIsAppTypeExists(response);
      return response;
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form className="ui form">
            <div className="ui segment">
              <h4 className="ui dividing header">Add Approval</h4>
              <div className="two fields">
                <Input
                  label="Code"
                  module={MODULES.Master}
                  form={FORM}
                  field="app_code"
                  editMode={editMode}
                  error={currentErrors.appCode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { appCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="approvalCode"
                  value={approvalHeaderData.appCode}
                  onChange={(e) => {
                    setApprovalHeaderData((prevState) => ({
                      ...prevState,
                      appCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />

                <Dropdown
                  required={true}
                  label="Approval Type"
                  module={MODULES.Master}
                  form={FORM}
                  readOnly={editMode}
                  field="app_approvals"
                  editMode={editMode}
                  error={currentErrors.appApprovals}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { appApprovals: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Approval Type"
                  options={approvalTypeOpt}
                  style={{ height: "20px" }}
                  value={approvalHeaderData.appApprovals}
                  onChange={(e, data) => {
                    const isExists = checkApprovalTypeExists(data.value);
                    if (isExists) {
                      setApprovalHeaderData((prevState) => ({
                        ...prevState,
                        appApprovals: data.value,
                        isApprovalTypeExists: isExists,
                      }));
                    }
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Name"
                  module={MODULES.Master}
                  form={FORM}
                  field="app_name"
                  editMode={editMode}
                  error={currentErrors.appName}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { appName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="approvalName"
                  value={approvalHeaderData.appName}
                  onChange={(e) => {
                    setApprovalHeaderData((prevState) => ({
                      ...prevState,
                      appName: e.target.value,
                    }));
                  }}
                />
                <Input
                  label="Description"
                  module={MODULES.Master}
                  form={FORM}
                  field="app_description"
                  editMode={editMode}
                  error={currentErrors.appDescription}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { appDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="Description"
                  value={approvalHeaderData.appDescription}
                  onChange={(e) => {
                    setApprovalHeaderData((prevState) => ({
                      ...prevState,
                      appDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  module={MODULES.Master}
                  form={FORM}
                  field="app_status"
                  editMode={editMode}
                  error={currentErrors.appStatus}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { appStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={appStatusOpt}
                  value={approvalHeaderData.appStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setApprovalHeaderData((prevState) => ({
                      ...prevState,
                      appStatus: data.value,
                    }));
                  }}
                />

                {/* <Dropdown
                  required={true}
                  label="Active"
                  module={MODULES.Master}
                  form={FORM}
                  field="app_active"
                  authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  error={currentErrors.appActive}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { appActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={appActiveOpt}
                  value={approvalHeaderData.appActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setApprovalHeaderData((prevState) => ({
                      ...prevState,
                      appActive: data.value,
                    }));
                  }}
                /> */}
              </div>
            </div>
          </form>
        )}
      </>
    );
  }
);

export default ApprovalMasterHeaderForm;
